<template>
 <div v-if="noBuy">
    <div class="sale-info">
    <div class="info-icon"><img :src="saleInfo.iconUrl" alt=""></div>
    <div class="title">{{ saleInfo.title }}</div>
    <div class="info">{{ saleInfo.content }}</div>
  </div>
  <div class="line-grey"></div>
 </div>
</template>

<script>
export default {
props:['noBuy', 'saleInfo']
}
</script>

<style lang="scss" scoped>
   .line-grey{
        height: 12px;
        background: #F7F7F7;
    }
.sale-info{
    background: #fff;
    padding: 48px 32px;
    margin-top: 12px;

    .info-icon{
        padding-bottom: 12px;
        text-align: center;
        img {
            width: 100px;
            height: 100px;
        }
    }
    .title{
        font-family: DiDiSans-Pro-Bold;
        font-size: 32px;
        color: #ff8040;
        text-align: center;
        line-height: 45px;
    }
    .info{
        opacity: 0.6;
        font-family: DiDiSans-Pro-Regular;
        font-size: 24px;
        color: #000000;
        text-align: center;
        line-height: 32px;
    }
}
</style>